import { extractOrgIdFromOrgKey } from '@legacy-modules/dashboard/utils/OrgKeyUtils';

interface OrgNodeLike {
  orgUnit?: { orgKey?: string };
  children?: OrgNodeLike[];
}

/**
 * DMT-741 org-aggregation (HADV parity): HADV's org chooser lets a user pick a single node, but a
 * parent node (e.g. a Depot) resolves to ALL of its descendant org IDs
 * (`SendungsbewegungDerOrganisation`/`XOrgChooser.getSelectedOrgs()`), and the combined stock of all
 * of them is shown in one merged result. This collects the numeric org ID of `node` plus every
 * descendant's org ID (duplicates/non-numeric keys are skipped), mirroring that same resolution on
 * the LMA UI side before calling the Restbestand API.
 */
export function collectSubtreeOrgIds(node: OrgNodeLike | null | undefined): number[] {
  const ids = new Set<number>();

  const walk = (n: OrgNodeLike | null | undefined): void => {
    if (!n) return;
    const orgKey = n.orgUnit?.orgKey;
    if (orgKey) {
      const raw = extractOrgIdFromOrgKey(orgKey);
      const id = raw ? parseInt(raw, 10) : NaN;
      if (!isNaN(id)) ids.add(id);
    }
    (n.children || []).forEach(walk);
  };

  walk(node);
  return Array.from(ids);
}
